import { EBundlesViewModel } from '@appcharge/shared-ui';
import {
  BannerAspectRatio,
  EBalancesTheme,
  EBundlesInternalViewModel,
  ELogoSize,
  ESectionViewModel
} from 'constants/enums';

export const defaultTheme = {
  general: {
    logo: 'https://media.appcharge.com/defaults/default-store-logo.svg',
    favicon: 'https://media.appcharge.com/defaults/default-store-logo.svg',
    storeTabName: 'Royal Blast Store',
    backgroundImageMobile:
      'https://media-dev.appcharge.com/media/defaults/Default_Appcharge_Background_Mobile.jpeg',
    backgroundImageDesktop:
      'https://media-dev.appcharge.com/media/defaults/Default_Appcharge_Background_Desktop.jpeg',
    storeSaleImage: '',
    font: 'montserrat',
    fontWeightForHeaders: '',
    fontWeightForText: '',
    buttonColor: {
      gradientDirection: '',
      colorOne: '#7122ff',
      colorTwo: '',
      solid: true
    },
    buttonTextColor: 'white',
    bundlesViewModel: EBundlesViewModel.LINEAR,
    bundlesInternalViewModel: EBundlesInternalViewModel.AK,
    specialOffersViewModel: 'gallery',
    specialOffersInternalViewModel: 'hug',
    rollingOffersInternalViewModel: 'huge',
    headerInternalViewModel: 'default',
    dailyBonusInternalViewModel: 'default',
    dailyBonusBadgeInternalViewModel: 'default',
    playerLevelInternalViewModel: 'default',
    progressBarInternalViewModel: 'default',
    footer: {
      imageMobile: '',
      imageDesktop: '',
      appstoreLink: '',
      googlePlayLink: '',
      privacyPolicyUrl: '',
      termsAndConditionsUrl: '',
      supportLink: '',
      supportParams: {
        playerIdParamName: '',
        playerNameParamName: ''
      },
      openLinksInNewTab: false
    },
    balancesTheme: EBalancesTheme.DEFAULT,
    sectionViewModel: ESectionViewModel.DEFAULT,
    sections: [],
    tabs: [],
    popupRatio: BannerAspectRatio.SQUARE,
    productQuantityFormat: {
      milSeparator: ',',
      fractionalSeparator: '.',
      thousandShorthand: false,
      millionShorthand: false,
      billionShorthand: false,
      trillionShorthand: false,
      quadrillionShorthand: false,
      quintillionShorthand: false
    },
    balanceQuantityFormat: {
      milSeparator: ',',
      fractionalSeparator: '.',
      thousandShorthand: false,
      millionShorthand: false,
      billionShorthand: false,
      trillionShorthand: false,
      quadrillionShorthand: false,
      quintillionShorthand: false
    },
    specialOfferQuantityFormat: {
      milSeparator: ',',
      fractionalSeparator: '.',
      thousandShorthand: false,
      millionShorthand: false,
      billionShorthand: false,
      trillionShorthand: false,
      quadrillionShorthand: false,
      quintillionShorthand: false
    },
    rollingOfferQuantityFormat: {
      milSeparator: ',',
      fractionalSeparator: '.',
      thousandShorthand: false,
      millionShorthand: false,
      billionShorthand: false,
      trillionShorthand: false,
      quadrillionShorthand: false,
      quintillionShorthand: false
    },
    accountApprovalModal: {
      backgroundImage: 'https://media.appcharge.com/defaults/background.png',
      backgroundColor: {
        gradientDirection: '',
        colorOne: '#7122ff',
        colorTwo: ''
      },
      borderColor: '#FFFFFF',
      borderWidth: 0,
      buttonTextColor: '#FFFFFF',
      buttonBackgroundColor: {
        gradientDirection: '',
        colorOne: '#7122ff',
        colorTwo: ''
      },
      textColor: '#FFFFFF',
      additionalText: ''
    }
  },
  login: {
    text: 'Welcome to a new members-only clubs',
    font: 'montserrat',
    textColor: 'white',
    textSize: 28,
    textWeight: 'bold',
    textOn: true,
    loginLogoImage: '',
    loginBackgroundImageMobile: '',
    loginBackgroundImageDesktop: '',
    loginLogoSize: ELogoSize.SMALL,
    otpButton: {
      backgroundColor: {
        gradientDirection: '',
        colorOne: '#7122ff',
        colorTwo: ''
      },
      text: 'OTP Text',
      icon: '',
      textColor: {
        gradientDirection: '',
        colorOne: '#7122ff',
        colorTwo: ''
      }
    },
    consentSection: {
      htmlText:
        '<p>By logging in you acknowledge that you have read and agree to the Privacy Policy And Terms and Conditions</p>',
      consentRequired: false
    }
  },
  storeScreen: {
    bundleBorderColor: {
      gradientDirection: '',
      colorOne: '#e3d3ff',
      colorTwo: '',
      solid: true
    },
    defaultBanner: '',
    noOffersTitleText: 'No offers available',
    noOffersMessageText: 'Please check back later.',
    borderSize: 0,
    header: {
      backgroundOpacity: 40,
      showLogo: true,
      showPlayerName: true,
      isSticky: false
    },
    addToHomeScreen: {
      active: false,
      verticalOffset: 0,
      buttonImage: '',
      iconImage: 'https://media.appcharge.com/defaults/default-store-logo.svg',
      shortcutName: 'Royal Blast Store',
      borderColor: {
        colorOne: '#ffffff',
        colorTwo: ''
      },
      backgroundColor: {
        colorOne: '#522AD8',
        colorTwo: ''
      }
    },
    backToGameButton: {
      active: false,
      buttonImage: ''
    }
  },
  completedScreen: {
    headerText: 'Success',
    headerColor: {
      gradientDirection: '',
      colorOne: 'white',
      colorTwo: '',
      solid: true
    },
    headerSize: 44,
    headerWeight: 'bold',
    headerOn: true,
    text: 'Open the game to see yuor new items',
    textColor: 'white',
    textSize: 24,
    textWeight: 'bold',
    textOn: true,
    backToGameButtonDeepLink: '',
    backToGameButtonText: 'Back to game'
  },
  integration: {
    deepLinks: {
      android: '',
      ios: '',
      web: ''
    }
  }
};
